export const LICENSE_FILTER = [
  { title: 'All Approvals', value: 'licences' },
  { title: 'My Approvals', value: 'my_licences' },
];

export enum REQUEST_STATUS {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  ALL = 'ALL'
}

export const REQUEST_MENU = [
  {
    title: 'Approved',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.APPROVED,
  },
  {
    title: 'Declined',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.DECLINED,
  },
  {
    title: 'Pending',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.PENDING,
  },
  {
    title: 'All',
    count: 0,
    route: '/home/admin-approval/coditas',
    status: REQUEST_STATUS.ALL,
  },
];

export const APPROVAL_SORTING_COLUMN = {
  TICKET_NUMBER: "TICKET_NUMBER",
  TICKET_DATE: "TICKET_DATE",
  TICKET_RAISED_BY: "TICKET_RAISED_BY",
  TICKET_ASSIGNED_TO: "TICKET_ASSIGNED_TO",
  ASSET_NAME: "ASSET_NAME",
  TICKET_STATUS: "TICKET_STATUS",
  APPROVAL_STATUS: "APPROVAL_STATUS",
};

export enum APPROVAL_STATUS {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
}

export type ApprovalStatus = 'DECLINED' | 'PENDING' | 'APPROVED' | 'ALL';

export const APPROVAL_PLACEHOLDERS = {
  DECLINED: {
    title: 'No Declined Approvals',
    subtitle: 'There are no declined approvals',
  },
  PENDING: {
    title: 'No Pending Approvals',
    subtitle: 'There are no pending approvals',
  },
  APPROVED: {
    title: 'No Approved Approvals',
    subtitle: 'There are no approved approvals',
  },
  ALL: {
    title: 'No Approvals',
    subtitle: 'There are no approvals to show',
  },
  DEFAULT: {
    title: 'No Approvals',
    subtitle: 'There are no approvals to show',
  },
  LICENSE: {
    title: 'No licenses requests found',
    subtitle: 'Once requests are submitted for license approval, they will appear here.'
  }
};

export const REQUEST_SEARCH_OPTIONS = [
  { title: 'Ticket No.', value: 'TICKET_NUMBER' },
  { title: 'Ticket Date', value: 'TICKET_DATE' },
  { title: 'Raised By', value: 'TICKET_RAISED_BY' },
  { title: 'Assigned to', value: 'TICKET_ASSIGNED_TO' }
];

export const REQUEST_SORT_COLUMNS = {
  ASSET_NAME: 'ASSET_NAME',
  PRIORITY: 'PRIORITY',
  TICKET_NUMBER: 'TICKET_NUMBER',
  TICKET_DATE: 'TICKET_DATE',
  ASSET_CODE: 'ASSET_CODE',
  REQUEST_STATUS: 'REQUEST_STATUS',
  REQUEST_RAISED_BY: 'REQUEST_RAISED_BY',
  ASSIGNED_TO: 'ASSIGNED_TO',
};

export const LICENSE_APPROVAL_FILTER = {
  ALL_LICENSE: 'licences',
  MY_LICENSE: 'my_licences'
}

export const DISPLAYED_COLUMNS = {
  whenMyApprovalStart: ['select'],
  commonStart: ['createdAt', 'ticketNumber'],
  whenNotMyApproval: ['ticketStatus'],
  commonMiddle: ['approvalStatus', 'keywords'],
  whenMyApprovalMiddle: ['status'],
  commonEnd: ['createdBy'],
  whenMyApprovalEnd: ['actions'],
};

export const APPROVAL_STATUS_TYPE = {
  LICENSE: 'LICENSE',
  ASSETS: 'ASSETS',
  ASSETS_SMALL: 'Assets'
}
